import {AppButton} from '@/components/AppButton';

interface Props {
    loading: boolean;
    children: string;
}

export const PublicSubmitButton = (props: Props) => {
    const {loading = false, children} = props;

    return (
        <AppButton
            type="submit"
            fullWidth
            variant="primary"
            size="large"
            loading={loading}
            sx={{mt: 3, mb: 2}}
        >
            {children}
        </AppButton>
    );
};
